import { useEffect, useState } from 'react'

// True only once `isActive` has held for `delayMs`, cleared immediately when it
// drops — so a fast load never flashes a skeleton, but a slow one still shows it.
export function useGretaAIChatDelayedFlag(isActive, delayMs) {
  const [isShown, setIsShown] = useState(false)

  useEffect(() => {
    let timeoutId = null

    if (isActive) {
      timeoutId = window.setTimeout(() => setIsShown(true), delayMs)
    }

    return () => {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId)
      }

      setIsShown(false)
    }
  }, [delayMs, isActive])

  return isShown
}
